import React, { ReactNode } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Translate } from 'react-redux-i18n';
import cartoucheHomme from '../../../../img/cartouche_homme.png';
import cartouchFemme from '../../../../img/cartouche_femme.png';
import btnDelegateRight from '../../../../img/accountManagement/btn_deleguer_droits.svg';
import btnBlock from '../../../../img/accountManagement/btn_bloquer.svg';
import btnLeave from '../../../../img/accountManagement/btn_depart.svg';
import btnDelegateRightSelected from '../../../../img/accountManagement/btn_revoquer_droits.svg';
import btnBlockSelected from '../../../../img/accountManagement/btn_debloquer.svg';
import btnDelegateRightDisabled from '../../../../img/accountManagement/btn_delguer_droits_disable.svg';
import btnBlockDisabled from '../../../../img/accountManagement/btn_bloquer_disable.svg';
import btnLeaveDisabled from '../../../../img/accountManagement/btn_depart_disable.svg';
import { MemberDTO } from '../../../../network/api/types/compte/MemberDTO';
import compteApi from '../../../../network/api/compteApi';
import ConfirmationModal from '../../../common/modals/ConfirmationModal';
import GestionnaireTile from './GestionnaireTile';
import { UserDTO } from '../../../../network/api/types/compte/UserDTO';
import { CompteProfilProProfileDetails } from '../../../../network/api/types/compte/CompteProfilProProfileDetails';
import {
  hasRightToBlock,
  hasRightToDelegate,
  hasRightToDeparture,
  hasRightToRemoveDelegation,
} from '../../../../services/RightService';
import { Entity } from '../../../../network/api/types/compte/Entity';

interface MatchParams {
  entiteId: string;
}

type Props = RouteComponentProps<MatchParams> & {
  member: MemberDTO,
  updateList: () => void,
  account?: UserDTO,
  entity?: Entity,
};

type State = {
  isBlocked: boolean,
  confimationModalOpen: boolean,
  modalTitleI18nKey: string,
  modalSubTitleI18nKey: string,
  confirmationButtonI18nKey: string,
  modalConfirmCallback: () => void,
  isLoading: boolean,
  photo?: string,
  nomDeNaissance?: string,
  civilite?: string,
};

class TileInformationBlock extends React.Component<Props, State> {
  state: State = {
    isBlocked: this.props.member.profilBloque,
    confimationModalOpen: false,
    modalTitleI18nKey: '',
    modalSubTitleI18nKey: '',
    confirmationButtonI18nKey: '',
    isLoading: false,
    modalConfirmCallback: () => {
    },
    photo: undefined,
    nomDeNaissance: undefined,
    civilite: undefined,
  };

  componentDidMount() {
    compteApi.fetchEntityMemberPersonalInfos(
      this.props.member.idn,
      this.props.match.params.entiteId,
    ).then((memberPersonalInfos) => this.setState({
      photo: memberPersonalInfos.photo,
      nomDeNaissance: memberPersonalInfos.nomDeNaissance,
      civilite: memberPersonalInfos.civilite,
    }));
  }

  getAvatar = (): JSX.Element => {
    if (this.state.photo) {
      return (<img alt="Profile pic" src={this.state.photo} />);
    }
    return (<img alt="Profile pic" src={this.state.civilite === 'Madame' ? cartouchFemme : cartoucheHomme} />);
  };

  toogleBlockPersonne = () => {
    this.setState({ isLoading: true });
    if (this.state.isBlocked) {
      compteApi.unBlockProfil(`${this.props.member.idn}_${this.props.match.params.entiteId}`)
        .then((response) => {
          if (response.success) {
            this.setState({ isBlocked: false, confimationModalOpen: false });
          }
        })
        .finally(() => this.setState({ isLoading: false }));
    } else {
      compteApi.blockProfil(`${this.props.member.idn}_${this.props.match.params.entiteId}`)
        .then((response) => {
          if (response.success) {
            this.setState({ isBlocked: true, confimationModalOpen: false });
          }
        })
        .finally(() => this.setState({ isLoading: false }));
    }
  };

  toogleDelegatePersonne = () => {
    this.setState({ isLoading: true });
    if (this.props.member.gestionnaire) {
      compteApi.removeDelegation(`${this.props.member.idn}_${this.props.match.params.entiteId}`)
        .then((response) => {
          if (response.success) {
            this.props.updateList();
          }
        })
        .catch(() => this.setState({ isLoading: false }));
    } else {
      compteApi.addDelegation(`${this.props.member.idn}_${this.props.match.params.entiteId}`)
        .then((response) => {
          if (response.success) {
            this.props.updateList();
          }
        })
        .catch(() => this.setState({ isLoading: false }));
    }
  };

  deleteFromEntite = () => {
    this.setState({ isLoading: true });
    compteApi.deleteFromEntite(`${this.props.member.idn}_${this.props.match.params.entiteId}`)
      .then((response) => {
        if (response.success) {
          this.props.updateList();
        }
      })
      .catch(() => this.setState({ isLoading: false }));
  };

  closeModal = () => {
    this.setState({ confimationModalOpen: false, isLoading: false });
  };

  openModal = (
    modalTitleI18nKey,
    modalSubTitleI18nKey,
    confirmationButtonI18nKey,
    modalConfirmCallback,
  ) => {
    this.setState({
      modalTitleI18nKey,
      modalSubTitleI18nKey,
      modalConfirmCallback,
      confirmationButtonI18nKey,
      confimationModalOpen: true,
    });
  };

  getDelegateButton = () =>
    (this.props.member.gestionnaire ? btnDelegateRightSelected : btnDelegateRight);

  getBlockButton = () => (this.state.isBlocked ? btnBlockSelected : btnBlock);

  isDelgateDisable = () => {
    if (this.state.isBlocked) {
      return true;
    }
    if (this.props.member.gestionnaire) {
      return !hasRightToRemoveDelegation(this.props.entity, this.props.member);
    }
    return !hasRightToDelegate(this.props.entity, this.props.member);
  };

  isBlockDisable = () =>
    !hasRightToBlock(
      this.props.entity,
      this.props.account,
      this.props.member,
      this.props.member.idn,
    );

  isLeaveDisable = () => {
    if (this.state.isBlocked) {
      return true;
    }
    return !hasRightToDeparture(
      this.props.entity,
      this.props.account,
      this.props.member,
      this.props.member.idn,
    );
  };

  render(): ReactNode {
    return (
      <>
        <ConfirmationModal
          titleI18nKey={this.state.modalTitleI18nKey}
          subtTitleI18nKey={this.state.modalSubTitleI18nKey}
          confirmationButtonI18nKey={this.state.confirmationButtonI18nKey}
          onConfirm={this.state.modalConfirmCallback}
          isOpen={this.state.confimationModalOpen}
          onClose={this.closeModal}
          confirmeDisabled={false}
          isLoading={this.state.isLoading}
        >
          <GestionnaireTile member={this.props.member} />
        </ConfirmationModal>
        <div className={`rattachement-tile ${this.state.isBlocked ? 'tile-disabled' : ''}`}>
          <div className="manage-colaborator-tile">
            <div className="picture-container">
              <div className="picture">
                {this.getAvatar()}
              </div>
              {
                this.state.isBlocked && (
                  <div className="blocked-tile-image-overlay">
                    <Translate value="collaborators.blockedAccount" />
                  </div>
                )
              }
            </div>
            <div>
              <div className="personne-name">
                {this.props.member.nomDaffichage}
              </div>
              {this.state.nomDeNaissance
              && this.state.nomDeNaissance !== this.props.member.nomUsuel
                ? (
                  <div className="personne-birthname">
                    {this.state.civilite
                    && this.state.civilite === 'Madame' ? 'née ' : 'né '}
                    {this.state.nomDeNaissance}
                  </div>
                )
                : (<div className="space-birthname"> né </div>)}
              <div className="caption personne-role">
                {this.props.member.fonction}
                {this.props.member.fonction?.toLowerCase().includes('collaborateur')
                && this.props.member.statut
                && (
                <span>
                  {' '}
                  {this.props.member.statut}
                </span>
                )}
              </div>
            </div>
            <div className="button-container">
              <button
                disabled={this.isDelgateDisable()}
                onClick={() =>
                  this.openModal(
                    `collaborators.delegateModal.title${this.props.member.gestionnaire ? 'Selected' : ''}`,
                    `collaborators.delegateModal.subTitle${this.props.member.gestionnaire ? 'Selected' : ''}`,
                    `collaborators.delegateModal.tooltip${this.props.member.gestionnaire ? 'Selected' : ''}`,

                    this.toogleDelegatePersonne,
                  )}
                className={`icon-button ${this.isDelgateDisable() ? 'btn-disabled' : ''}`}
                type="button"
              >
                <img
                  alt="button-delegate"
                  src={
                    this.isDelgateDisable()
                      ? btnDelegateRightDisabled
                      : this.getDelegateButton()
                  }
                />
                {
                  !this.isDelgateDisable()
                  && (
                    <div className="tooltip">
                      <div className="arrow-up" />
                      <div className="tooltip-content">
                        <Translate
                          value={`collaborators.delegateModal.tooltip${this.props.member.gestionnaire ? 'Selected' : ''}`}
                        />
                      </div>
                    </div>
                  )
                }
              </button>
              <button
                disabled={this.isBlockDisable()}
                onClick={() =>
                  this.openModal(
                    `collaborators.blockModal.title${this.state.isBlocked ? 'Selected' : ''}`,
                    `collaborators.blockModal.subTitle${this.state.isBlocked ? 'Selected' : ''}`,
                    `collaborators.blockModal.tooltip${this.state.isBlocked ? 'Selected' : ''}`,
                    this.toogleBlockPersonne,
                  )}
                className={`icon-button ${this.isBlockDisable() ? 'btn-disabled' : ''}`}
                type="button"
              >
                <img
                  alt="button-block"
                  src={
                    this.isBlockDisable()
                      ? btnBlockDisabled
                      : this.getBlockButton()
                  }
                />
                {
                  !this.isBlockDisable()
                  && (
                    <div className="tooltip">
                      <div className="arrow-up" />
                      <div className="tooltip-content">
                        <Translate
                          value={`collaborators.blockModal.tooltip${this.state.isBlocked ? 'Selected' : ''}`}
                        />
                      </div>
                    </div>
                  )
                }
              </button>
              <button
                disabled={this.isLeaveDisable()}
                onClick={() =>
                  this.openModal(
                    'collaborators.leaveModal.title',
                    'collaborators.leaveModal.subTitle',
                    'collaborators.leaveModal.tooltip',
                    this.deleteFromEntite,
                  )}
                className={`icon-button ${this.isLeaveDisable() ? 'btn-disabled' : ''}`}
                type="button"
              >
                <img alt="button-leave" src={this.isLeaveDisable() ? btnLeaveDisabled : btnLeave} />
                {
                  !this.isLeaveDisable()
                  && (
                    <div className="tooltip">
                      <div className="arrow-up" />
                      <div className="tooltip-content">
                        <Translate value="collaborators.leaveModal.tooltip" />
                      </div>
                    </div>
                  )
                }
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(TileInformationBlock);
